import { Injectable } from '@angular/core'
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { map } from 'rxjs/operators'
import { AuthenticationService } from '../_services/authentication.service'

@Injectable({
  providedIn: 'root',
})
export class CountryGuardGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.currentUser$.pipe(map(user=>{
      const { country } = user
      if (country.toLowerCase() === 'uganda') {
        // authorised admin so return true
        return true
      }
      this.router.navigateByUrl('/mobile-agronomical')
      return false
    }))

  }
}
